export interface LineInitializer {
  id: number;
  originalLineId: number;
  name: string;
}

export default class Line {
  public readonly id: number;
  public readonly originalLineId: number;
  public readonly name: string;

  constructor(init: LineInitializer) {
    this.id = init.id;
    this.originalLineId = init.originalLineId;
    this.name = init.name;
  }
}
